// extracted by mini-css-extract-plugin
module.exports = {"primary":"primary-ajdA5","active":"active-290_B"};